/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_2_AnswerInputs */

const en_svc_agents_faq_2_answer = /** @type {(inputs: Svc_Agents_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, if they offer an API, and most do: HubSpot and other CRMs, Gmail, Microsoft 365, Slack, Google Sheets and many industry tools. We confirm what can connect during discovery.`)
};

const lv_svc_agents_faq_2_answer = /** @type {(inputs: Svc_Agents_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā, ja tiem ir API, un lielākajai daļai ir: HubSpot un citām CRM, Gmail, Microsoft 365, Slack, Google Sheets un daudziem nozares rīkiem. Ko var savienot, pārbaudām izpētes laikā.`)
};

/**
* | output |
* | --- |
* | "Yes, if they offer an API, and most do: HubSpot and other CRMs, Gmail, Microsoft 365, Slack, Google Sheets and many industry tools. We confirm what can conne..." |
*
* @param {Svc_Agents_Faq_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_2_answer = /** @type {((inputs?: Svc_Agents_Faq_2_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_2_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_2_answer(inputs)
	return en_svc_agents_faq_2_answer(inputs)
});